import { faPhone } from '@awesome.me/kit-5452b20ec3/icons/classic/light'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { MDVIP_LOGIN_LINK, MDVIP_PHONE, MDVIP_PHONE_HREF } from '../../Constants'
import Button from '../form-elements/Button'
import styles from './Header.module.scss'

const Header = () => {
  return (
    <header>
      <div className={styles['header']}>
        <div className={styles['header-wrapper']}>
          <a
            href="https://www.mdvip.com"
            target="_blank"
            title="Link to MDVIP homepage"
            rel="noreferrer"
            aria-label="MDVIP homepage"
          >
            <svg
              width="114"
              height="25"
              viewBox="0 0 114 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-label="MDVIP logo"
              role="img"
            >
              <title>MDVIP logo</title>
              <path
                d="M32.9292 0.0661011V22.8727H29.5931V0.0661011H22.8172L15.4029 16.6778L7.1776 0.0661011H0.00488281V24.6558H3.41581V5.61101L12.8893 24.6501H15.6445L24.1459 5.62251V19.1569C24.1459 23.5112 26.6193 24.6501 29.6391 24.6501H43.2137C50.5878 24.6501 56.7194 20.6409 56.7194 12.2833C56.7194 3.92568 50.9271 0.0661011 42.5177 0.0661011H32.9292ZM42.4717 21.9811H38.5144V2.74077H42.0288C47.4184 2.74077 50.6395 6.05391 50.6395 12.2373C50.6395 18.4207 47.4242 21.9811 42.4257 21.9811H42.4775H42.4717ZM91.8122 0.0661011V24.6558H97.4549V16.3442H103.391C109.131 16.3442 113.238 13.3762 113.238 8.22816C113.238 3.08014 109.126 0.0661011 103.385 0.0661011H91.8064H91.8122ZM97.4491 13.6235V2.78679H101.458C105.663 2.78679 107.987 4.61592 107.987 8.13037C107.987 11.6448 105.663 13.6235 101.458 13.6235H97.4491ZM88.4703 0.0661011V24.6501H82.8334V2.32088H81.0042L70.9153 24.6501H67.1535L54.9938 0.0661011H61.0276L69.4888 16.9827L70.0812 18.1676L76.673 3.45402C78.0592 0.29618 80.1127 0.0661011 82.7816 0.0661011H88.4703Z"
                fill="black"
              />
            </svg>
          </a>
          <div className={styles['phone']}>
            <FontAwesomeIcon icon={faPhone} className={styles['phone-icon']} />
            <a
              className={`${styles['phone-number']} ${styles['link']}`}
              href={MDVIP_PHONE_HREF}
              rel="noopener noreferrer"
              aria-label={`Call MDVIP at ${MDVIP_PHONE}`}
            >
              {MDVIP_PHONE}
            </a>
            <a
              className={styles['link']}
              href={MDVIP_LOGIN_LINK}
              target="_blank"
              rel="noreferrer noopener"
              aria-label="MDVIP member login page"
            >
              Log In
            </a>
          </div>
          <Button
            rounded
            variant="secondary"
            type="button"
            className={styles['login-button']}
            aria-label="Login to MDVIP"
            onClick={() => window.open(MDVIP_LOGIN_LINK, '_blank', 'noopener,noreferrer')}
          >
            Login
          </Button>
        </div>
      </div>
    </header>
  )
}

export default Header
